import { render, staticRenderFns } from "./ProjectStatusesForm.vue?vue&type=template&id=4a47df65&"
import script from "./ProjectStatusesForm.vue?vue&type=script&lang=js&"
export * from "./ProjectStatusesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports